<div class="container mt-4 mb-5 ml-5 mr-5 full-background-color">
  <div class="row">
    <div class="col-sm-5 pt-3">
      <form #loginForm="ngForm" (ngSubmit)="login()">
        <img
          src=" /assets/images/logo-namavirunthu.png"
          alt="Welcome Image"
          class="img-fluid mx-auto d-block"
          style="width: 60%; margin-bottom: -80px"
        />
        <div class="pt-5 pl-5">
          <p class="mb-0" style="color: white; font-weight: bold">Username</p>
          <input
            type="text"
            class="form_filed"
            name="username"
            [(ngModel)]="username"
            required
          />
          <div
            *ngIf="
              loginForm.controls['username']?.errors?.required &&
              loginForm.controls['username']?.touched
            "
            class="error-message"
          >
            Username is required.
          </div>

          <p class="mt-2 mb-0" style="color: white; font-weight: bold">
            Password
          </p>
          <div class="password-input-container">
            <input
              type="{{ showPassword ? 'text' : 'password' }}"
              class="form_filed password-input"
              name="password"
              [(ngModel)]="password"
              required
            />
            <div
              *ngIf="
                loginForm.controls['password']?.errors?.required &&
                loginForm.controls['password']?.touched
              "
              class="error-message"
            >
              Password is required
            </div>

            <i
              class="password-icon fas fa-eye"
              [ngClass]="showPassword ? 'fa-eye' : 'fa-eye-slash'"
              (click)="togglePasswordVisibility()"
            ></i>
          </div>
          <div *ngIf="errorMessage" class="error-message">
            {{ errorMessage }}
          </div>
          <div class="remember-me mt-2">
            <input
              type="checkbox"
              id="rememberMe"
              [(ngModel)]="rememberMe"
              name="rememberMe"
              class="form-check-input"
            />
            <label for="rememberMe" style="color: white">Remember Me</label>
          </div>
        </div>

        <div class="d-flex justify-content-between pl-5 mt-3">
          <a href="/#/auth/forgotpassword" class="forgot-password-link"
            >Forgot Password?</a
          >
        </div>
        <div class="form-group1 center-buttons">
          <button
            nbButton
            status="primary"
            type="submit"
            class="center-button"
            [ngClass]="{ 'login-button': !loginForm.invalid }"
            style="
              background-color: rgb(245, 67, 12);
              color: white;
              border-radius: 10px;
              width: 150px;
              padding: 10px 20px;
            "
          >
            Login
          </button>
        </div>
      </form>
    </div>
    <div class="col-sm-7 left-design pb-5 pt-3">
      <div
        class="slideshow-container d-flex justify-content-center align-items-center"
      >
        <!-- <div class="slideshow-container text-center"> -->
        <img
          *ngFor="let image of slideshowImages; let i = index"
          [src]="image"
          [class.active]="i === slideIndex"
          class="slideshow-image"
          style="height: 260px; width: auto"
        />
      </div>
      <div class="caption-container">
        <h1>Welcome to <span class="highlight">Namma Virundhu</span></h1>
      </div>
    </div>
  </div>
</div>
